import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-documento',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './documento.component.html',
  styleUrls: ['./documento.component.css'],
})
export class DocumentoComponent implements OnInit {
  documentoForm!: FormGroup; // Declaración como FormGroup
  id_documento!: number; // Declaración obligatoria
  hoy: string;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) {
    // Inicializar la fecha actual en formato YYYY-MM-DD
    const hoy = new Date();
    const utc5 = new Date(hoy.getTime() - 5 * 60 * 60 * 1000); // Restar 5 horas
    const fechaUTC5 = utc5.toISOString().split('T')[0];
    this.hoy = fechaUTC5;
  }

  ngOnInit(): void {
    // Inicializar formulario
    this.documentoForm = this.fb.group({
      nombre: [
        { value: '' },
        [Validators.required, Validators.maxLength(100)],
      ],
      descripcion: [{ value: '' }],
      tipo_documento: [{ value: '',}, Validators.required],
      fecha_inicio: [{ value: ''}, Validators.required],
      fecha_fin: [{ value: '' }, Validators.required],
      link_formato: [{ value: ''}],
    });

    // Obtener y validar id_documento
    this.route.queryParams.subscribe((params) => {
      this.id_documento = params['id_documento'];
    });
    //console.log(this.id_documento);
    if (!this.id_documento) {
      Swal.fire('Error', 'Documento no válido.', 'error').then(() => {
        this.router.navigate(['/documentos']);
      });
      return;
    }

    this.cargarDocumento();
  }

  cargarDocumento(): void {
    this.http
      .get(environment.apiUrl + `/documento/${this.id_documento}`)
      .subscribe(
        (response: any) => {
          this.documentoForm.patchValue({
            nombre: response.nombre,
            descripcion: response.descripcion,
            tipo_documento: response.tipo_documento,
            fecha_inicio: response.fecha_inicio
              ? response.fecha_inicio.split('T')[0]
              : '',
            fecha_fin: response.fecha_fin
              ? response.fecha_fin.split('T')[0]
              : '',
            link_formato: response.link_formato,
          });
        },
        (error) => {
          Swal.fire(
            'Error',
            error.error.message || 'Error al obtener el documento.',
            'error'
          );
        }
      );
  }



  actualizarDocumento(): void {
    if (this.documentoForm.invalid) {
      Swal.fire('Advertencia', 'Hay errores en el formulario.', 'warning');
      return;
    }

    Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Quieres actualizar el documento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, actualizar',
      cancelButtonText: 'No, cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const data = {
          ...this.documentoForm.value,
          fecha_inicio: this.documentoForm.value.fecha_inicio,
          fecha_fin: this.documentoForm.value.fecha_fin,
        };

        this.http
          .patch(environment.apiUrl + `/documento/${this.id_documento}`, data)
          .subscribe(
            (response) => {
              Swal.fire(
                'Éxito',
                'Documento actualizado correctamente.',
                'success'
              ).then(() => {
                this.router.navigate(['/documentos']);
              });
            },
            (error) => {
              //console.error('Error al actualizar el documento:', error);
              Swal.fire(
                'Error',
                error.error.message || 'Error al actualizar el documento.',
                'error'
              );
            }
          );
      }
    });
  }

  volver(): void {
    if (this.documentoForm.dirty) {
      Swal.fire({
        title: 'Cambios no guardados',
        text: '¿Estás seguro de salir sin guardar los cambios?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, salir',
        cancelButtonText: 'No, quedarse',
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/documentos']);
        }
      });
    } else {
      this.router.navigate(['/documentos']);
    }
  }
}
